import { ActivatedRouteSnapshot, PRIMARY_OUTLET } from '@angular/router';
import { BreadcrumbConfig, IBreadcrumb } from '../models/breadcrumb.models';

const appendUrl = (base: string, route: ActivatedRouteSnapshot): string => {
  const path = route.url.map((segment) => segment.path).join('/');
  return path ? `${base}/${path}` : base;
};

const toCrumbs = (
  config: BreadcrumbConfig,
  url: string,
  route: ActivatedRouteSnapshot
): IBreadcrumb[] => {
  if (typeof config === 'string') {
    return [{ label: config, url, translate: true }];
  }
  if (Array.isArray(config)) {
    return config.map((key, index) => ({
      label: key,
      url: index === config.length - 1 ? url : null,
      translate: true,
    }));
  }
  const value = route.params[config.param];
  return value ? [{ label: value, url, translate: false }] : [];
};

export const buildBreadcrumbTrail = (
  root: ActivatedRouteSnapshot
): IBreadcrumb[] => {
  const crumbs: IBreadcrumb[] = [];
  let route: ActivatedRouteSnapshot | undefined = root;
  let url = '';

  while (route) {
    url = appendUrl(url, route);
    const config = route.routeConfig?.data?.['breadcrumb'] as
      BreadcrumbConfig | undefined;
    if (config) {
      crumbs.push(...toCrumbs(config, url, route));
    }
    route = route.children.find((child) => child.outlet === PRIMARY_OUTLET);
  }

  if (crumbs.length) {
    crumbs[crumbs.length - 1].url = null;
  }
  return crumbs;
};
